import { render, staticRenderFns } from "./DAcademicInfo.vue?vue&type=template&id=009080af&"
import script from "./DAcademicInfo.vue?vue&type=script&lang=js&"
export * from "./DAcademicInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports